"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const boxStyles = {
  alignItems: "center",
  display: "inline-flex",
  alignContent: "center",
  gap: SpaceXxs,
  flexWrap: "wrap"
};
const btnWriteReview = {
  ...boxStyles,
  borderRadius: 0,
  height: "auto",
  padding: 0,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "none"
  }
};
const smallIconStyles = {
  width: "14px",
  height: "14px"
};
const mediumIconStyles = {
  width: "18px",
  height: "18px"
};
const largeIconStyles = {
  width: "24px",
  height: "24px"
};
const StyledStarRatings = styled(Box, {
  shouldForwardProp: (prop) => prop !== "displayAvgRatingAsText"
})(() => ({
  position: "relative",
  display: "inline-flex",
  color: "transparent"
}));
const StyledRatingsOverlay = styled(Box)(
  ({ width, color }) => ({
    overflow: "hidden",
    position: "absolute",
    color,
    width: `${width}%`,
    display: "inline-flex"
  })
);
const StyledSpan = styled("span")(
  ({ displayVariant }) => ({
    textDecoration: displayVariant === "full" ? "underline" : "none"
  })
);
export {
  StyledRatingsOverlay,
  StyledSpan,
  StyledStarRatings,
  boxStyles,
  btnWriteReview,
  largeIconStyles,
  mediumIconStyles,
  smallIconStyles
};
